// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import { useState } from 'react';
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import { MainLogo } from '../components/constants';
import * as styles from '../styles/OpenAiHeader.styles';

export const OpenAiHeader = (): JSX.Element => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>): void => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = (): void => {
    setAnchorEl(null);
  };

  const handleLogout = (): void => {
    alert('Logout clicked');
    handleMenuClose();
  };

  return (
    <>
      <header style={styles.headerStyle}>
        <div style={styles.headerLogoWrapperStyle}>
          <MainLogo />
        </div>

        <div style={styles.headerUserSectionStyle}>
          {/* <IconButton onClick={handleMenuOpen} style={styles.headerIconButtonStyle}>
            O
          </IconButton>

           <div style={styles.userInfoWrapperStyle}>
            <span style={styles.userNameStyle}>Olivia Rhye</span>
            <span style={styles.userEmailStyle}>olivia@email.com</span>
          </div>

          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleMenuClose}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          >
            <MenuItem onClick={handleLogout}>
              <ListItemIcon>
                <LogoutOutlinedIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Logout</ListItemText>
            </MenuItem>
          </Menu> */}
        </div>
      </header>
    </>
  );
};
